import store from "../store";

export default (to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if(isLoggedIn){
    next()
  }else{
    const { params: { merchant_code='invalid-merchant-code' } } = to;
    next({path:`/${merchant_code}/login`, query: { next_page: to.name }});
  }
}


// WEBPACK FOOTER //
// ./src/router/UserAuth.js